/*
 * @Author: shannyHuang
 * @Date: 2022-06-15 11:36:37
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-08-10 17:12:26
 * @FilePath: /wemeet-web-activity/src/pages/create/mobile/BgField.tsx
 */
/** 个人背景上传/预览Field */
import React, { FC, useCallback, useState } from 'react';
import classnames from 'classnames';
import ReactDOM from 'react-dom';
import { Form } from '@tencent/tea-component';
import { FormItemProps } from '@tencent/tea-component/es/form/FormItem';

import style from './index.module.scss';

const DefaultBannerM = '';
interface BgFormProps extends FormItemProps {
  value?: any;
}
const BgField: FC<Partial<BgFormProps>> = (props) => {
  const [preview, setPreview] = useState(false);
  const { value = DefaultBannerM } = props;
  const show = () => setPreview(true);
  const hide = () => setPreview(false);
  return (
    <Form.Item {...props} onClick={show}>
      <FormField preview={preview} hide={hide} value={value} />
    </Form.Item>
  );
};

const FormField: FC<{ value?: string; preview: boolean; hide(): void }> = (props) => (
  <>
    <ImgPreview {...props} />
    <div style={{ backgroundImage: `url(${props.value})` }} className="form-img"></div>
  </>
);

const ImgPreview: FC<{ value?: string; preview: boolean; hide(): void }> = ({
  value,
  preview,
  hide,
}) => {
  const click = useCallback((e) => {
    e.stopPropagation();
    hide();
  }, []);
  return ReactDOM.createPortal(
    <div
      className={classnames(style['img-preview-mask'], { [style.show]: preview })}
      onClick={click}
    >
      <div className="form-img" style={{ backgroundImage: value || DefaultBannerM }}></div>
      <div className={classnames(style['img-preview-tips'])}>
        暂不支持修改，如需更改请前往桌面版
      </div>
    </div>,
    document.body,
  );
};

BgField.displayName = 'BgField';

export default BgField;
